export const UserInformationdocuments = [
    
    {
      type: 'text', 
      question_no: 'full_name', 
      question: 'Enter Full Name', 
      description: '', 
      depend_question: '', 
      condition: 'equals', 
      value: 'yes', 
      validation:'text', 
      options: []
      , 
      mandatory: 1,
    },
    {
      type: 'email', 
      question_no: 'email_id', 
      question: 'Enter Email ID', 
      description: 'Kindly note that this email id will also be your login, so enter an email id that you will have continued access to', 
      depend_question: '', 
      condition: 'equals', 
      value: 'yes', 
      validation:'email', 
      options: []
      , 
      mandatory: 1,
    },
    {
      type: 'number', 
      question_no: 'mobile_number', 
      question: 'Mobile Number', 
      description: 'Kindly note that the mobile number will be used for login authentication and to recover your account', 
      depend_question: '', 
      condition: 'equals', 
      value: 'yes', 
      validation:'mobile', 
      options: []
      , 
      mandatory: 0,
    },
    {
      type: 'text', 
      question_no: 'password', 
      question: 'Password', 
      description: '', 
      depend_question: '', 
      condition: 'equals', 
      value: 'yes', 
      validation:'text', 
      options: []
      , 
      mandatory: 1,
    },
    {
      type: 'dropdown', 
      question_no: 'location', 
      question: 'Location', 
      description: 'Select one country from the dropdown', 
      depend_question: '', 
      condition: 'equals', 
      value: 'yes', 
      validation:'dropdown', 
      mandatory: 1,
      options: [
        { option: 'India' },
        { option: 'Afghanistan' },
        { option: 'Albania' },
        { option: 'Algeria' },
        { option: 'Andorra' },
        { option: 'Angola' },
        { option: 'Antigua and Barbuda' },
        { option: 'Argentina' },
        { option: 'Armenia' },
        { option: 'Australia' },
        { option: 'Austria' },
        { option: 'Azerbaijan' },
        { option: 'Bahamas' },
        { option: 'Bahrain' },
        { option: 'Bangladesh' },
        { option: 'Barbados' },
        { option: 'Belarus' },
        { option: 'Belgium' },
        { option: 'Belize' },
        { option: 'Benin' },
        { option: 'Bhutan' },
        { option: 'Bolivia' },
        { option: 'Bosnia and Herzegovina' },
        { option: 'Botswana' },
        { option: 'Brazil' },
        { option: 'Brunei' },
        { option: 'Bulgaria' },
        { option: 'Burkina Faso' },
        { option: 'Burundi' },
        { option: 'Cabo Verde' },
        { option: 'Cambodia' },
        { option: 'Cameroon' },
        { option: 'Canada' },
        { option: 'Central African Republic' },
        { option: 'Chad' },
        { option: 'Chile' },
        { option: 'China' },
        { option: 'Colombia' },
        { option: 'Comoros' },
        { option: 'Congo (Congo-Brazzaville)' },
        { option: 'Costa Rica' },
        { option: 'Croatia' },
        { option: 'Cuba' },
        { option: 'Cyprus' },
        { option: 'Czech Republic' },
        { option: 'Democratic Republic of the Congo' },
        { option: 'Denmark' },
        { option: 'Djibouti' },
        { option: 'Dominica' },
        { option: 'Dominican Republic' },
        { option: 'East Timor (Timor-Leste)' },
        { option: 'Ecuador' },
        { option: 'Egypt' },
        { option: 'El Salvador' },
        { option: 'Equatorial Guinea' },
        { option: 'Eritrea' },
        { option: 'Estonia' },
        { option: 'Eswatini (Swaziland)' },
        { option: 'Ethiopia' },
        { option: 'Fiji' },
        { option: 'Finland' },
        { option: 'France' },
        { option: 'Gabon' },
        { option: 'Gambia' },
        { option: 'Georgia' },
        { option: 'Germany' },
        { option: 'Ghana' },
        { option: 'Greece' },
        { option: 'Grenada' },
        { option: 'Guatemala' },
        { option: 'Guinea' },
        { option: 'Guinea-Bissau' },
        { option: 'Guyana' },
        { option: 'Haiti' },
        { option: 'Honduras' },
        { option: 'Hungary' },
        { option: 'Iceland' },
        { option: 'Indonesia' },
        { option: 'Iran' },
        { option: 'Iraq' },
        { option: 'Ireland' },
        { option: 'Israel' },
        { option: 'Italy' },
        { option: 'Ivory Coast' },
        { option: 'Jamaica' },
        { option: 'Japan' },
        { option: 'Jordan' },
        { option: 'Kazakhstan' },
        { option: 'Kenya' },
        { option: 'Kiribati' },
        { option: 'Kosovo' },
        { option: 'Kuwait' },
        { option: 'Kyrgyzstan' },
        { option: 'Laos' },
        { option: 'Latvia' },
        { option: 'Lebanon' },
        { option: 'Lesotho' },
        { option: 'Liberia' },
        { option: 'Libya' },
        { option: 'Liechtenstein' },
        { option: 'Lithuania' },
        { option: 'Luxembourg' },
        { option: 'Madagascar' },
        { option: 'Malawi' },
        { option: 'Malaysia' },
        { option: 'Maldives' },
        { option: 'Mali' },
        { option: 'Malta' },
        { option: 'Marshall Islands' },
        { option: 'Mauritania' },
        { option: 'Mauritius' },
        { option: 'Mexico' },
        { option: 'Micronesia' },
        { option: 'Moldova' },
        { option: 'Monaco' },
        { option: 'Mongolia' },
        { option: 'Montenegro' },
        { option: 'Morocco' },
        { option: 'Mozambique' },
        { option: 'Myanmar (Burma)' },
        { option: 'Namibia' },
        { option: 'Nauru' },
        { option: 'Nepal' },
        { option: 'Netherlands' },
        { option: 'New Zealand' },
        { option: 'Nicaragua' },
        { option: 'Niger' },
        { option: 'Nigeria' },
        { option: 'North Korea' },
        { option: 'North Macedonia' },
        { option: 'Norway' },
        { option: 'Oman' },
        { option: 'Pakistan' },
        { option: 'Palau' },
        { option: 'Panama' },
        { option: 'Papua New Guinea' },
        { option: 'Paraguay' },
        { option: 'Peru' },
        { option: 'Philippines' },
        { option: 'Poland' },
        { option: 'Portugal' },
        { option: 'Qatar' },
        { option: 'Romania' },
        { option: 'Russia' },
        { option: 'Rwanda' },
        { option: 'Saint Kitts and Nevis' },
        { option: 'Saint Lucia' },
        { option: 'Saint Vincent and the Grenadines' },
        { option: 'Samoa' },
        { option: 'San Marino' },
        { option: 'Sao Tome and Principe' },
        { option: 'Saudi Arabia' },
        { option: 'Senegal' },
        { option: 'Serbia' },
        { option: 'Seychelles' },
        { option: 'Sierra Leone' },
        { option: 'Singapore' },
        { option: 'Slovakia' },
        { option: 'Slovenia' },
        { option: 'Solomon Islands' },
        { option: 'Somalia' },
        { option: 'South Africa' },
        { option: 'South Korea' },
        { option: 'South Sudan' },
        { option: 'Spain' },
        { option: 'Sri Lanka' },
        { option: 'Sudan' },
        { option: 'Suriname' },
        { option: 'Sweden' },
        { option: 'Switzerland' },
        { option: 'Syria' },
        { option: 'Taiwan' },
        { option: 'Tajikistan' },
        { option: 'Tanzania' },
        { option: 'Thailand' },
        { option: 'Togo' },
        { option: 'Tonga' },
        { option: 'Trinidad and Tobago' },
        { option: 'Tunisia' },
        { option: 'Turkey' },
        { option: 'Turkmenistan' },
        { option: 'Tuvalu' },
        { option: 'Uganda' },
        { option: 'Ukraine' },
        { option: 'United Arab Emirates' },
        { option: 'United Kingdom' },
        { option: 'United States of America' },
        { option: 'Uruguay' },
        { option: 'Uzbekistan' },
        { option: 'Vanuatu' },
        { option: 'Vatican City' },
        { option: 'Venezuela' },
        { option: 'Vietnam' },
        { option: 'Yemen' },
        { option: 'Zambia' },
        { option: 'Zimbabwe' }
      ]
      , 
    },
]

export const PurposeCheckBoxData = [
  {
    label: 'To verify credentials of NPOs/NGOs',
    name: 'to_verify_npo',
  },
  {
    label: 'To search for NPO/NGO products',
    name: 'to_search_npo',
  },
  {
    label: 'To find NPOs/NGOs',
    name: 'to_find_npo',
  },
  {
    label: 'To volunteer',
    name: 'to_volunteer',
  },
  {
    label: 'To donate',
    name: 'to_donate',
  },
  {
    label: 'To learn about the NPO/NGO sector',
    name: 'to_learn',
  },
  {
    label: 'To give in-kind',
    name: 'to_give_in_kind',
  },
  {
    label: 'For research',
    name: 'for_research',
  },
  {
    label: 'Select all options of interest to you',
    name: 'thematic_area',
    isCustomInput: true,
    mandatory: 0,
    options: [
      {"option": "Culture and arts "},
      {"option": "Sports"},
      {"option": "Other recreation and social clubs"},
      {"option": "Education"},
      {"option": "Research"},
      {"option": "Health"},
      {"option": "Mental health and crisis intervention"},
      {"option": "Other health services"},
      {"option": "Child welfare, child services and day care"},
      {"option": "Youth services and youth welfare"},
      {"option": "Family services"},
      {"option": "Services for the handicapped"},
      {"option": "Services for the elderly"},
      {"option": "Self-help and other personal social services"},
      {"option": "Emergency and relief"},
      {"option": "Income / Material support and maintenance "},
      {"option": "Environment"},
      {"option": "Animal Protection and welfare"},
      {"option": "Economic, Social and community development"},
      {"option": "Housing"},
      {"option": "Livelihoods, Employment and Training"},
      {"option": "Civic and advocacy organizations"},
      {"option": "Law and legal services "},
      {"option": "Political Organisations"},
      {"option": "Philanthropic intermediaries and voluntarism promotion"},
      {"option": "International activities "},
      {"option": "Religious congregations and associations"},
      {"option": "Business and professional associations, unions "},
      {"option": "Other"},
    ]
  },
  {Geography : [
    {
      label: 'Select State(s) that is of interest to you.',
      name: 'geography_state',
      isCustomInput: true,
      mandatory: 0, 
      options: [
        { option: 'Andaman and Nicobar Islands (UT)' },
        { option: 'Andhra Pradesh' },
        { option: 'Arunachal Pradesh' },
        { option: 'Assam' },
        { option: 'Bihar' },
        { option: 'Chandigarh (UT)' },
        { option: 'Chhattisgarh' },
        { option: 'Dadra and Nagar Haveli and Daman and Diu (UT)' },
        { option: 'Delhi (NCT)' },
        { option: 'Goa' },
        { option: 'Gujarat' },
        { option: 'Haryana' },
        { option: 'Himachal Pradesh' },
        { option: 'Jammu and Kashmir (UT)' },
        { option: 'Jharkhand' },
        { option: 'Karnataka' },
        { option: 'Kerala' },
        { option: 'Ladakh (UT)' },
        { option: 'Lakshadweep (UT)' },
        { option: 'Madhya Pradesh' },
        { option: 'Maharashtra' },
        { option: 'Manipur' },
        { option: 'Meghalaya' },
        { option: 'Mizoram' },
        { option: 'Nagaland' },
        { option: 'Odisha' },
        { option: 'Puducherry (UT)' },
        { option: 'Punjab' },
        { option: 'Rajasthan' },
        { option: 'Sikkim' },
        { option: 'Tamil Nadu' },
        { option: 'Telangana' },
        { option: 'Tripura' },
        { option: 'Uttar Pradesh' },
        { option: 'Uttarakhand' },
        { option: 'West Bengal' }
      ]
    },
    {
      label: 'Select District(s) that is of interest to you.',
      name: 'district',
      isCustomInput: true,
      options: [
        {
          option: "Nicobar",
          value: "Andaman and Nicobar Islands (UT)",
          explanation: "",
        },
        {
          option: "North and Middle Andaman",
          value: "Andaman and Nicobar Islands (UT)",
          explanation: "",
        },
        {
          option: "South Andaman",
          value: "Andaman and Nicobar Islands (UT)",
          explanation: "",
        },
        {
          option: "Anantapur",
          value: "Andhra Pradesh",
          explanation: "",
        },
        {
          option: "Chittoor",
          value: "Andhra Pradesh",
          explanation: "",
        },
        {
          option: "East Godavari",
          value: "Andhra Pradesh",
          explanation: "",
        },
        {
          option: "Guntur",
          value: "Andhra Pradesh",
          explanation: "",
        },
        {
          option: "Krishna",
          value: "Andhra Pradesh",
          explanation: "",
        },
        {
          option: "Kurnool",
          value: "Andhra Pradesh",
          explanation: "",
        },
        {
          option: "Prakasam",
          value: "Andhra Pradesh",
          explanation: "",
        },
        {
          option: "Sri Potti Sriramulu Nellore",
          value: "Andhra Pradesh",
          explanation: "",
        },
        {
          option: "Srikakulam",
          value: "Andhra Pradesh",
          explanation: "",
        },
        {
          option: "Visakhapatnam",
          value: "Andhra Pradesh",
          explanation: "",
        },
        {
          option: "Vizianagaram",
          value: "Andhra Pradesh",
          explanation: "",
        },
        {
          option: "West Godavari",
          value: "Andhra Pradesh",
          explanation: "",
        },
        {
          option: "YSR District, Kadapa (Cuddapah)",
          value: "Andhra Pradesh",
          explanation: "",
        },
        {
          option: "Anjaw",
          value: "Arunachal Pradesh",
          explanation: "",
        },
        {
          option: "Changlang",
          value: "Arunachal Pradesh",
          explanation: "",
        },
        {
          option: "Dibang Valley",
          value: "Arunachal Pradesh",
          explanation: "",
        },
        {
          option: "East Kameng",
          value: "Arunachal Pradesh",
          explanation: "",
        },
        {
          option: "East Siang",
          value: "Arunachal Pradesh",
          explanation: "",
        },
        {
          option: "Kamle",
          value: "Arunachal Pradesh",
          explanation: "",
        },
        {
          option: "Kra Daadi",
          value: "Arunachal Pradesh",
          explanation: "",
        },
        {
          option: "Kurung Kumey",
          value: "Arunachal Pradesh",
          explanation: "",
        },
        {
          option: "Lepa Rada",
          value: "Arunachal Pradesh",
          explanation: "",
        },
        {
          option: "Lohit",
          value: "Arunachal Pradesh",
          explanation: "",
        },
        {
          option: "Longding",
          value: "Arunachal Pradesh",
          explanation: "",
        },
        {
          option: "Lower Dibang Valley",
          value: "Arunachal Pradesh",
          explanation: "",
        },
        {
          option: "Lower Siang",
          value: "Arunachal Pradesh",
          explanation: "",
        },
        {
          option: "Lower Subansiri",
          value: "Arunachal Pradesh",
          explanation: "",
        },
        {
          option: "Namsai",
          value: "Arunachal Pradesh",
          explanation: "",
        },
        {
          option: "Pakke Kessang",
          value: "Arunachal Pradesh",
          explanation: "",
        },
        {
          option: "Papum Pare",
          value: "Arunachal Pradesh",
          explanation: "",
        },
        {
          option: "Shi Yomi",
          value: "Arunachal Pradesh",
          explanation: "",
        },
        {
          option: "Siang",
          value: "Arunachal Pradesh",
          explanation: "",
        },
        {
          option: "Tawang",
          value: "Arunachal Pradesh",
          explanation: "",
        },
        {
          option: "Tirap",
          value: "Arunachal Pradesh",
          explanation: "",
        },
        {
          option: "Upper Siang",
          value: "Arunachal Pradesh",
          explanation: "",
        },
        {
          option: "Upper Subansiri",
          value: "Arunachal Pradesh",
          explanation: "",
        },
        {
          option: "West Kameng",
          value: "Arunachal Pradesh",
          explanation: "",
        },
        {
          option: "West Siang",
          value: "Arunachal Pradesh",
          explanation: "",
        },
        {
          option: "Baksa",
          value: "Assam",
          explanation: "",
        },
        {
          option: "Barpeta",
          value: "Assam",
          explanation: "",
        },
        {
          option: "Biswanath",
          value: "Assam",
          explanation: "",
        },
        {
          option: "Bongaigaon",
          value: "Assam",
          explanation: "",
        },
        {
          option: "Cachar",
          value: "Assam",
          explanation: "",
        },
        {
          option: "Charaideo",
          value: "Assam",
          explanation: "",
        },
        {
          option: "Chirang",
          value: "Assam",
          explanation: "",
        },
        {
          option: "Darrang",
          value: "Assam",
          explanation: "",
        },
        {
          option: "Dhemaji",
          value: "Assam",
          explanation: "",
        },
        {
          option: "Dhubri",
          value: "Assam",
          explanation: "",
        },
        {
          option: "Dibrugarh",
          value: "Assam",
          explanation: "",
        },
        {
          option: "Dima Hasao (North Cachar Hills)",
          value: "Assam",
          explanation: "",
        },
        {
          option: "Goalpara",
          value: "Assam",
          explanation: "",
        },
        {
          option: "Golaghat",
          value: "Assam",
          explanation: "",
        },
        {
          option: "Hailakandi",
          value: "Assam",
          explanation: "",
        },
        {
          option: "Hojai",
          value: "Assam",
          explanation: "",
        },
        {
          option: "Jorhat",
          value: "Assam",
          explanation: "",
        },
        {
          option: "Kamrup",
          value: "Assam",
          explanation: "",
        },
        {
          option: "Kamrup Metropolitan",
          value: "Assam",
          explanation: "",
        },
        {
          option: "Karbi Anglong",
          value: "Assam",
          explanation: "",
        },
        {
          option: "Karimganj",
          value: "Assam",
          explanation: "",
        },
        {
          option: "Kokrajhar",
          value: "Assam",
          explanation: "",
        },
        {
          option: "Lakhimpur",
          value: "Assam",
          explanation: "",
        },
        {
          option: "Majuli",
          value: "Assam",
          explanation: "",
        },
        {
          option: "Morigaon",
          value: "Assam",
          explanation: "",
        },
        {
          option: "Nagaon",
          value: "Assam",
          explanation: "",
        },
        {
          option: "Nalbari",
          value: "Assam",
          explanation: "",
        },
        {
          option: "Sivasagar",
          value: "Assam",
          explanation: "",
        },
        {
          option: "Sonitpur",
          value: "Assam",
          explanation: "",
        },
        {
          option: "South Salamara-Mankachar",
          value: "Assam",
          explanation: "",
        },
        {
          option: "Tinsukia",
          value: "Assam",
          explanation: "",
        },
        {
          option: "Udalguri",
          value: "Assam",
          explanation: "",
        },
        {
          option: "West Karbi Anglong",
          value: "Assam",
          explanation: "",
        },
        {
          option: "Araria",
          value: "Bihar",
          explanation: "",
        },
        {
          option: "Arwal",
          value: "Bihar",
          explanation: "",
        },
        {
          option: "Aurangabad (BH)",
          value: "Bihar",
          explanation: "",
        },
        {
          option: "Banka",
          value: "Bihar",
          explanation: "",
        },
        {
          option: "Begusarai",
          value: "Bihar",
          explanation: "",
        },
        {
          option: "Bhagalpur",
          value: "Bihar",
          explanation: "",
        },
        {
          option: "Bhojpur",
          value: "Bihar",
          explanation: "",
        },
        {
          option: "Buxar",
          value: "Bihar",
          explanation: "",
        },
        {
          option: "Darbhanga",
          value: "Bihar",
          explanation: "",
        },
        {
          option: "East Champaran (Motihari)",
          value: "Bihar",
          explanation: "",
        },
        {
          option: "Gaya",
          value: "Bihar",
          explanation: "",
        },
        {
          option: "Gopalganj",
          value: "Bihar",
          explanation: "",
        },
        {
          option: "Jamui",
          value: "Bihar",
          explanation: "",
        },
        {
          option: "Jehanabad",
          value: "Bihar",
          explanation: "",
        },
        {
          option: "Kaimur (Bhabua)",
          value: "Bihar",
          explanation: "",
        },
        {
          option: "Katihar",
          value: "Bihar",
          explanation: "",
        },
        {
          option: "Khagaria",
          value: "Bihar",
          explanation: "",
        },
        {
          option: "Kishanganj",
          value: "Bihar",
          explanation: "",
        },
        {
          option: "Lakhisarai",
          value: "Bihar",
          explanation: "",
        },
        {
          option: "Madhepura",
          value: "Bihar",
          explanation: "",
        },
        {
          option: "Madhubani",
          value: "Bihar",
          explanation: "",
        },
        {
          option: "Munger (Monghyr)",
          value: "Bihar",
          explanation: "",
        },
        {
          option: "Muzaffarpur",
          value: "Bihar",
          explanation: "",
        },
        {
          option: "Nalanda",
          value: "Bihar",
          explanation: "",
        },
        {
          option: "Nawada",
          value: "Bihar",
          explanation: "",
        },
        {
          option: "Patna",
          value: "Bihar",
          explanation: "",
        },
        {
          option: "Purnia (Purnea)",
          value: "Bihar",
          explanation: "",
        },
        {
          option: "Rohtas",
          value: "Bihar",
          explanation: "",
        },
        {
          option: "Saharsa",
          value: "Bihar",
          explanation: "",
        },
        {
          option: "Samastipur",
          value: "Bihar",
          explanation: "",
        },
        {
          option: "Saran",
          value: "Bihar",
          explanation: "",
        },
        {
          option: "Sheikhpura",
          value: "Bihar",
          explanation: "",
        },
        {
          option: "Sheohar",
          value: "Bihar",
          explanation: "",
        },
        {
          option: "Sitamarhi",
          value: "Bihar",
          explanation: "",
        },
        {
          option: "Siwan",
          value: "Bihar",
          explanation: "",
        },
        {
          option: "Supaul",
          value: "Bihar",
          explanation: "",
        },
        {
          option: "Vaishali",
          value: "Bihar",
          explanation: "",
        },
        {
          option: "West Champaran",
          value: "Bihar",
          explanation: "",
        },
        {
          option: "Chandigarh",
          value: "Chandigarh (UT)",
          explanation: "",
        },
        {
          option: "Balod",
          value: "Chhattisgarh",
          explanation: "",
        },
        {
          option: "Baloda Bazar",
          value: "Chhattisgarh",
          explanation: "",
        },
        {
          option: "Balrampur",
          value: "Chhattisgarh",
          explanation: "",
        },
        {
          option: "Bastar",
          value: "Chhattisgarh",
          explanation: "",
        },
        {
          option: "Bemetara",
          value: "Chhattisgarh",
          explanation: "",
        },
        {
          option: "Bijapur",
          value: "Chhattisgarh",
          explanation: "",
        },
        {
          option: "Bilaspur",
          value: "Chhattisgarh",
          explanation: "",
        },
        {
          option: "Dantewada (South Bastar)",
          value: "Chhattisgarh",
          explanation: "",
        },
        {
          option: "Dhamtari",
          value: "Chhattisgarh",
          explanation: "",
        },
        {
          option: "Durg",
          value: "Chhattisgarh",
          explanation: "",
        },
        {
          option: "Gariyaband",
          value: "Chhattisgarh",
          explanation: "",
        },
        {
          option: "Janjgir-Champa",
          value: "Chhattisgarh",
          explanation: "",
        },
        {
          option: "Jashpur",
          value: "Chhattisgarh",
          explanation: "",
        },
        {
          option: "Kabirdham (Kawardha)",
          value: "Chhattisgarh",
          explanation: "",
        },
        {
          option: "Kanker (North Bastar)",
          value: "Chhattisgarh",
          explanation: "",
        },
        {
          option: "Kondagaon",
          value: "Chhattisgarh",
          explanation: "",
        },
        {
          option: "Korba",
          value: "Chhattisgarh",
          explanation: "",
        },
        {
          option: "Korea (Koriya)",
          value: "Chhattisgarh",
          explanation: "",
        },
        {
          option: "Mahasamund",
          value: "Chhattisgarh",
          explanation: "",
        },
        {
          option: "Mungeli",
          value: "Chhattisgarh",
          explanation: "",
        },
        {
          option: "Narayanpur",
          value: "Chhattisgarh",
          explanation: "",
        },
        {
          option: "Raigarh",
          value: "Chhattisgarh",
          explanation: "",
        },
        {
          option: "Raipur",
          value: "Chhattisgarh",
          explanation: "",
        },
        {
          option: "Rajnandgaon",
          value: "Chhattisgarh",
          explanation: "",
        },
        {
          option: "Sukma",
          value: "Chhattisgarh",
          explanation: "",
        },
        {
          option: "Surajpur",
          value: "Chhattisgarh",
          explanation: "",
        },
        {
          option: "Surguja",
          value: "Chhattisgarh",
          explanation: "",
        },
        {
          option: "Dadra & Nagar Haveli",
          value: "Dadra and Nagar Haveli and Daman and Diu (UT)",
          explanation: "",
        },
        {
          option: "Daman",
          value: "Dadra and Nagar Haveli and Daman and Diu (UT)",
          explanation: "",
        },
        {
          option: "Diu",
          value: "Dadra and Nagar Haveli and Daman and Diu (UT)",
          explanation: "",
        },
        {
          option: "Central Delhi",
          value: "Delhi (NCT)",
          explanation: "",
        },
        {
          option: "East Delhi",
          value: "Delhi (NCT)",
          explanation: "",
        },
        {
          option: "New Delhi",
          value: "Delhi (NCT)",
          explanation: "",
        },
        {
          option: "North Delhi",
          value: "Delhi (NCT)",
          explanation: "",
        },
        {
          option: "North East Delhi",
          value: "Delhi (NCT)",
          explanation: "",
        },
        {
          option: "North West Delhi",
          value: "Delhi (NCT)",
          explanation: "",
        },
        {
          option: "Shahdara",
          value: "Delhi (NCT)",
          explanation: "",
        },
        {
          option: "South Delhi",
          value: "Delhi (NCT)",
          explanation: "",
        },
        {
          option: "South East Delhi",
          value: "Delhi (NCT)",
          explanation: "",
        },
        {
          option: "South West Delhi",
          value: "Delhi (NCT)",
          explanation: "",
        },
        {
          option: "West Delhi",
          value: "Delhi (NCT)",
          explanation: "",
        },
        {
          option: "North Goa",
          value: "Goa",
          explanation: "",
        },
        {
          option: "South Goa",
          value: "Goa",
          explanation: "",
        },
        {
          option: "Ahmedabad",
          value: "Gujarat",
          explanation: "",
        },
        {
          option: "Amreli",
          value: "Gujarat",
          explanation: "",
        },
        {
          option: "Anand",
          value: "Gujarat",
          explanation: "",
        },
        {
          option: "Aravalli",
          value: "Gujarat",
          explanation: "",
        },
        {
          option: "Banaskantha (Palanpur)",
          value: "Gujarat",
          explanation: "",
        },
        {
          option: "Bharuch",
          value: "Gujarat",
          explanation: "",
        },
        {
          option: "Bhavnagar",
          value: "Gujarat",
          explanation: "",
        },
        {
          option: "Botad",
          value: "Gujarat",
          explanation: "",
        },
        {
          option: "Chhota Udepur",
          value: "Gujarat",
          explanation: "",
        },
        {
          option: "Dahod",
          value: "Gujarat",
          explanation: "",
        },
        {
          option: "Dangs (Ahwa)",
          value: "Gujarat",
          explanation: "",
        },
        {
          option: "Devbhoomi Dwarka",
          value: "Gujarat",
          explanation: "",
        },
        {
          option: "Gandhinagar",
          value: "Gujarat",
          explanation: "",
        },
        {
          option: "Gir Somnath",
          value: "Gujarat",
          explanation: "",
        },
        {
          option: "Jamnagar",
          value: "Gujarat",
          explanation: "",
        },
        {
          option: "Junagadh",
          value: "Gujarat",
          explanation: "",
        },
        {
          option: "Kachchh",
          value: "Gujarat",
          explanation: "",
        },
        {
          option: "Kheda (Nadiad)",
          value: "Gujarat",
          explanation: "",
        },
        {
          option: "Mahisagar",
          value: "Gujarat",
          explanation: "",
        },
        {
          option: "Mehsana",
          value: "Gujarat",
          explanation: "",
        },
        {
          option: "Morbi",
          value: "Gujarat",
          explanation: "",
        },
        {
          option: "Narmada (Rajpipla)",
          value: "Gujarat",
          explanation: "",
        },
        {
          option: "Navsari",
          value: "Gujarat",
          explanation: "",
        },
        {
          option: "Panchmahal (Godhra)",
          value: "Gujarat",
          explanation: "",
        },
        {
          option: "Patan",
          value: "Gujarat",
          explanation: "",
        },
        {
          option: "Porbandar",
          value: "Gujarat",
          explanation: "",
        },
        {
          option: "Rajkot",
          value: "Gujarat",
          explanation: "",
        },
        {
          option: "Sabarkantha (Himmatnagar)",
          value: "Gujarat",
          explanation: "",
        },
        {
          option: "Surat",
          value: "Gujarat",
          explanation: "",
        },
        {
          option: "Surendranagar",
          value: "Gujarat",
          explanation: "",
        },
        {
          option: "Tapi (Vyara)",
          value: "Gujarat",
          explanation: "",
        },
        {
          option: "Vadodara",
          value: "Gujarat",
          explanation: "",
        },
        {
          option: "Valsad",
          value: "Gujarat",
          explanation: "",
        },
        {
          option: "Ambala",
          value: "Haryana",
          explanation: "",
        },
        {
          option: "Bhiwani",
          value: "Haryana",
          explanation: "",
        },
        {
          option: "Charkhi Dadri",
          value: "Haryana",
          explanation: "",
        },
        {
          option: "Faridabad",
          value: "Haryana",
          explanation: "",
        },
        {
          option: "Fatehabad",
          value: "Haryana",
          explanation: "",
        },
        {
          option: "Gurugram (Gurgaon)",
          value: "Haryana",
          explanation: "",
        },
        {
          option: "Hisar",
          value: "Haryana",
          explanation: "",
        },
        {
          option: "Jhajjar",
          value: "Haryana",
          explanation: "",
        },
        {
          option: "Jind",
          value: "Haryana",
          explanation: "",
        },
        {
          option: "Kaithal",
          value: "Haryana",
          explanation: "",
        },
        {
          option: "Karnal",
          value: "Haryana",
          explanation: "",
        },
        {
          option: "Kurukshetra",
          value: "Haryana",
          explanation: "",
        },
        {
          option: "Mahendragarh",
          value: "Haryana",
          explanation: "",
        },
        {
          option: "Nuh",
          value: "Haryana",
          explanation: "",
        },
        {
          option: "Palwal",
          value: "Haryana",
          explanation: "",
        },
        {
          option: "Panchkula",
          value: "Haryana",
          explanation: "",
        },
        {
          option: "Panipat",
          value: "Haryana",
          explanation: "",
        },
        {
          option: "Rewari",
          value: "Haryana",
          explanation: "",
        },
        {
          option: "Rohtak",
          value: "Haryana",
          explanation: "",
        },
        {
          option: "Sirsa",
          value: "Haryana",
          explanation: "",
        },
        {
          option: "Sonipat",
          value: "Haryana",
          explanation: "",
        },
        {
          option: "Yamunanagar",
          value: "Haryana",
          explanation: "",
        },
        {
          option: "Bilaspur (HP)",
          value: "Himachal Pradesh",
          explanation: "",
        },
        {
          option: "Chamba",
          value: "Himachal Pradesh",
          explanation: "",
        },
        {
          option: "Hamirpur (HP)",
          value: "Himachal Pradesh",
          explanation: "",
        },
        {
          option: "Kangra",
          value: "Himachal Pradesh",
          explanation: "",
        },
        {
          option: "Kinnaur",
          value: "Himachal Pradesh",
          explanation: "",
        },
        {
          option: "Kullu",
          value: "Himachal Pradesh",
          explanation: "",
        },
        {
          option: "Lahaul & Spiti",
          value: "Himachal Pradesh",
          explanation: "",
        },
        {
          option: "Mandi",
          value: "Himachal Pradesh",
          explanation: "",
        },
        {
          option: "Shimla",
          value: "Himachal Pradesh",
          explanation: "",
        },
        {
          option: "Sirmaur (Sirmour)",
          value: "Himachal Pradesh",
          explanation: "",
        },
        {
          option: "Solan",
          value: "Himachal Pradesh",
          explanation: "",
        },
        {
          option: "Una",
          value: "Himachal Pradesh",
          explanation: "",
        },
        {
          option: "Anantnag",
          value: "Jammu and Kashmir(UT)",
          explanation: "",
        },
        {
          option: "Bandipore",
          value: "Jammu and Kashmir(UT)",
          explanation: "",
        },
        {
          option: "Baramulla",
          value: "Jammu and Kashmir(UT)",
          explanation: "",
        },
        {
          option: "Budgam",
          value: "Jammu and Kashmir(UT)",
          explanation: "",
        },
        {
          option: "Doda",
          value: "Jammu and Kashmir(UT)",
          explanation: "",
        },
        {
          option: "Ganderbal",
          value: "Jammu and Kashmir(UT)",
          explanation: "",
        },
        {
          option: "Jammu",
          value: "Jammu and Kashmir(UT)",
          explanation: "",
        },
        {
          option: "Kathua",
          value: "Jammu and Kashmir(UT)",
          explanation: "",
        },
        {
          option: "Kishtwar",
          value: "Jammu and Kashmir(UT)",
          explanation: "",
        },
        {
          option: "Kulgam",
          value: "Jammu and Kashmir(UT)",
          explanation: "",
        },
        {
          option: "Kupwara",
          value: "Jammu and Kashmir(UT)",
          explanation: "",
        },
        {
          option: "Poonch",
          value: "Jammu and Kashmir(UT)",
          explanation: "",
        },
        {
          option: "Pulwama",
          value: "Jammu and Kashmir(UT)",
          explanation: "",
        },
        {
          option: "Rajouri",
          value: "Jammu and Kashmir(UT)",
          explanation: "",
        },
        {
          option: "Ramban",
          value: "Jammu and Kashmir(UT)",
          explanation: "",
        },
        {
          option: "Reasi",
          value: "Jammu and Kashmir(UT)",
          explanation: "",
        },
        {
          option: "Samba",
          value: "Jammu and Kashmir(UT)",
          explanation: "",
        },
        {
          option: "Shopian",
          value: "Jammu and Kashmir(UT)",
          explanation: "",
        },
        {
          option: "Srinagar",
          value: "Jammu and Kashmir(UT)",
          explanation: "",
        },
        {
          option: "Udhampur",
          value: "Jammu and Kashmir(UT)",
          explanation: "",
        },
        {
          option: "Bokaro",
          value: "Jharkhand",
          explanation: "",
        },
        {
          option: "Chatra",
          value: "Jharkhand",
          explanation: "",
        },
        {
          option: "Deoghar",
          value: "Jharkhand",
          explanation: "",
        },
        {
          option: "Dhanbad",
          value: "Jharkhand",
          explanation: "",
        },
        {
          option: "Dumka",
          value: "Jharkhand",
          explanation: "",
        },
        {
          option: "East Singhbhum",
          value: "Jharkhand",
          explanation: "",
        },
        {
          option: "Garhwa",
          value: "Jharkhand",
          explanation: "",
        },
        {
          option: "Giridih",
          value: "Jharkhand",
          explanation: "",
        },
        {
          option: "Godda",
          value: "Jharkhand",
          explanation: "",
        },
        {
          option: "Gumla",
          value: "Jharkhand",
          explanation: "",
        },
        {
          option: "Hazaribag",
          value: "Jharkhand",
          explanation: "",
        },
        {
          option: "Jamtara",
          value: "Jharkhand",
          explanation: "",
        },
        {
          option: "Khunti",
          value: "Jharkhand",
          explanation: "",
        },
        {
          option: "Koderma",
          value: "Jharkhand",
          explanation: "",
        },
        {
          option: "Latehar",
          value: "Jharkhand",
          explanation: "",
        },
        {
          option: "Lohardaga",
          value: "Jharkhand",
          explanation: "",
        },
        {
          option: "Pakur",
          value: "Jharkhand",
          explanation: "",
        },
        {
          option: "Palamu",
          value: "Jharkhand",
          explanation: "",
        },
        {
          option: "Ramgarh",
          value: "Jharkhand",
          explanation: "",
        },
        {
          option: "Ranchi",
          value: "Jharkhand",
          explanation: "",
        },
        {
          option: "Sahibganj",
          value: "Jharkhand",
          explanation: "",
        },
        {
          option: "Seraikela-Kharsawan",
          value: "Jharkhand",
          explanation: "",
        },
        {
          option: "Simdega",
          value: "Jharkhand",
          explanation: "",
        },
        {
          option: "West Singhbhum",
          value: "Jharkhand",
          explanation: "",
        },
        {
          option: "Bagalkot",
          value: "Karnataka",
          explanation: "",
        },
        {
          option: "Ballari (Bellary)",
          value: "Karnataka",
          explanation: "",
        },
        {
          option: "Belagavi (Belgaum)",
          value: "Karnataka",
          explanation: "",
        },
        {
          option: "Bengaluru (Bangalore) Rural",
          value: "Karnataka",
          explanation: "",
        },
        {
          option: "Bengaluru (Bangalore) Urban",
          value: "Karnataka",
          explanation: "",
        },
        {
          option: "Bidar",
          value: "Karnataka",
          explanation: "",
        },
        {
          option: "Chamarajanagar",
          value: "Karnataka",
          explanation: "",
        },
        {
          option: "Chikballapur",
          value: "Karnataka",
          explanation: "",
        },
        {
          option: "Chikkamagaluru (Chikmagalur)",
          value: "Karnataka",
          explanation: "",
        },
        {
          option: "Chitradurga",
          value: "Karnataka",
          explanation: "",
        },
        {
          option: "Dakshina Kannada",
          value: "Karnataka",
          explanation: "",
        },
        {
          option: "Davangere",
          value: "Karnataka",
          explanation: "",
        },
        {
          option: "Dharwad",
          value: "Karnataka",
          explanation: "",
        },
        {
          option: "Gadag",
          value: "Karnataka",
          explanation: "",
        },
        {
          option: "Hassan",
          value: "Karnataka",
          explanation: "",
        },
        {
          option: "Haveri",
          value: "Karnataka",
          explanation: "",
        },
        {
          option: "Kalaburagi (Gulbarga)",
          value: "Karnataka",
          explanation: "",
        },
        {
          option: "Kodagu",
          value: "Karnataka",
          explanation: "",
        },
        {
          option: "Kolar",
          value: "Karnataka",
          explanation: "",
        },
        {
          option: "Koppal",
          value: "Karnataka",
          explanation: "",
        },
        {
          option: "Mandya",
          value: "Karnataka",
          explanation: "",
        },
        {
          option: "Mysuru (Mysore)",
          value: "Karnataka",
          explanation: "",
        },
        {
          option: "Raichur",
          value: "Karnataka",
          explanation: "",
        },
        {
          option: "Ramanagara",
          value: "Karnataka",
          explanation: "",
        },
        {
          option: "Shivamogga (Shimoga)",
          value: "Karnataka",
          explanation: "",
        },
        {
          option: "Tumakuru (Tumkur)",
          value: "Karnataka",
          explanation: "",
        },
        {
          option: "Udupi",
          value: "Karnataka",
          explanation: "",
        },
        {
          option: "Uttara Kannada (Karwar)",
          value: "Karnataka",
          explanation: "",
        },
        {
          option: "Vijayapura (Bijapur)",
          value: "Karnataka",
          explanation: "",
        },
        {
          option: "Yadgir",
          value: "Karnataka",
          explanation: "",
        },
        {
          option: "Alappuzha",
          value: "Kerala",
          explanation: "",
        },
        {
          option: "Ernakulam",
          value: "Kerala",
          explanation: "",
        },
        {
          option: "Idukki",
          value: "Kerala",
          explanation: "",
        },
        {
          option: "Kannur",
          value: "Kerala",
          explanation: "",
        },
        {
          option: "Kasaragod",
          value: "Kerala",
          explanation: "",
        },
        {
          option: "Kollam",
          value: "Kerala",
          explanation: "",
        },
        {
          option: "Kottayam",
          value: "Kerala",
          explanation: "",
        },
        {
          option: "Kozhikode",
          value: "Kerala",
          explanation: "",
        },
        {
          option: "Malappuram",
          value: "Kerala",
          explanation: "",
        },
        {
          option: "Palakkad",
          value: "Kerala",
          explanation: "",
        },
        {
          option: "Pathanamthitta",
          value: "Kerala",
          explanation: "",
        },
        {
          option: "Thiruvananthapuram",
          value: "Kerala",
          explanation: "",
        },
        {
          option: "Thrissur",
          value: "Kerala",
          explanation: "",
        },
        {
          option: "Wayanad",
          value: "Kerala",
          explanation: "",
        },
        {
          option: "Kargil",
          value: "Ladakh(UT)",
          explanation: "",
        },
        {
          option: "Leh",
          value: "Ladakh(UT)",
          explanation: "",
        },
        {
          option: "Lakshadweep",
          value: "Lakshadweep (UT)",
          explanation: "",
        },
        {
          option: "Agar Malwa",
          value: "Madhya Pradesh",
          explanation: "",
        },
        {
          option: "Alirajpur",
          value: "Madhya Pradesh",
          explanation: "",
        },
        {
          option: "Anuppur",
          value: "Madhya Pradesh",
          explanation: "",
        },
        {
          option: "Ashoknagar",
          value: "Madhya Pradesh",
          explanation: "",
        },
        {
          option: "Balaghat",
          value: "Madhya Pradesh",
          explanation: "",
        },
        {
          option: "Barwani",
          value: "Madhya Pradesh",
          explanation: "",
        },
        {
          option: "Betul",
          value: "Madhya Pradesh",
          explanation: "",
        },
        {
          option: "Bhind",
          value: "Madhya Pradesh",
          explanation: "",
        },
        {
          option: "Bhopal",
          value: "Madhya Pradesh",
          explanation: "",
        },
        {
          option: "Burhanpur",
          value: "Madhya Pradesh",
          explanation: "",
        },
        {
          option: "Chhatarpur",
          value: "Madhya Pradesh",
          explanation: "",
        },
        {
          option: "Chhindwara",
          value: "Madhya Pradesh",
          explanation: "",
        },
        {
          option: "Damoh",
          value: "Madhya Pradesh",
          explanation: "",
        },
        {
          option: "Datia",
          value: "Madhya Pradesh",
          explanation: "",
        },
        {
          option: "Dewas",
          value: "Madhya Pradesh",
          explanation: "",
        },
        {
          option: "Dhar",
          value: "Madhya Pradesh",
          explanation: "",
        },
        {
          option: "Dindori",
          value: "Madhya Pradesh",
          explanation: "",
        },
        {
          option: "Guna",
          value: "Madhya Pradesh",
          explanation: "",
        },
        {
          option: "Gwalior",
          value: "Madhya Pradesh",
          explanation: "",
        },
        {
          option: "Harda",
          value: "Madhya Pradesh",
          explanation: "",
        },
        {
          option: "Hoshangabad",
          value: "Madhya Pradesh",
          explanation: "",
        },
        {
          option: "Indore",
          value: "Madhya Pradesh",
          explanation: "",
        },
        {
          option: "Jabalpur",
          value: "Madhya Pradesh",
          explanation: "",
        },
        {
          option: "Jhabua",
          value: "Madhya Pradesh",
          explanation: "",
        },
        {
          option: "Katni",
          value: "Madhya Pradesh",
          explanation: "",
        },
        {
          option: "Khandwa",
          value: "Madhya Pradesh",
          explanation: "",
        },
        {
          option: "Khargone",
          value: "Madhya Pradesh",
          explanation: "",
        },
        {
          option: "Mandla",
          value: "Madhya Pradesh",
          explanation: "",
        },
        {
          option: "Mandsaur",
          value: "Madhya Pradesh",
          explanation: "",
        },
        {
          option: "Morena",
          value: "Madhya Pradesh",
          explanation: "",
        },
        {
          option: "Narsinghpur",
          value: "Madhya Pradesh",
          explanation: "",
        },
        {
          option: "Neemuch",
          value: "Madhya Pradesh",
          explanation: "",
        },
        {
          option: "Panna",
          value: "Madhya Pradesh",
          explanation: "",
        },
        {
          option: "Raisen",
          value: "Madhya Pradesh",
          explanation: "",
        },
        {
          option: "Rajgarh",
          value: "Madhya Pradesh",
          explanation: "",
        },
        {
          option: "Ratlam",
          value: "Madhya Pradesh",
          explanation: "",
        },
        {
          option: "Rewa",
          value: "Madhya Pradesh",
          explanation: "",
        },
        {
          option: "Sagar",
          value: "Madhya Pradesh",
          explanation: "",
        },
        {
          option: "Satna",
          value: "Madhya Pradesh",
          explanation: "",
        },
        {
          option: "Sehore",
          value: "Madhya Pradesh",
          explanation: "",
        },
        {
          option: "Seoni",
          value: "Madhya Pradesh",
          explanation: "",
        },
        {
          option: "Shahdol",
          value: "Madhya Pradesh",
          explanation: "",
        },
        {
          option: "Shajapur",
          value: "Madhya Pradesh",
          explanation: "",
        },
        {
          option: "Sheopur",
          value: "Madhya Pradesh",
          explanation: "",
        },
        {
          option: "Shivpuri",
          value: "Madhya Pradesh",
          explanation: "",
        },
        {
          option: "Sidhi",
          value: "Madhya Pradesh",
          explanation: "",
        },
        {
          option: "Singrauli",
          value: "Madhya Pradesh",
          explanation: "",
        },
        {
          option: "Tikamgarh",
          value: "Madhya Pradesh",
          explanation: "",
        },
        {
          option: "Ujjain",
          value: "Madhya Pradesh",
          explanation: "",
        },
        {
          option: "Umaria",
          value: "Madhya Pradesh",
          explanation: "",
        },
        {
          option: "Vidisha",
          value: "Madhya Pradesh",
          explanation: "",
        },
        {
          option: "Ahmednagar",
          value: "Maharashtra",
          explanation: "",
        },
        {
          option: "Akola",
          value: "Maharashtra",
          explanation: "",
        },
        {
          option: "Amravati",
          value: "Maharashtra",
          explanation: "",
        },
        {
          option: "Aurangabad",
          value: "Maharashtra",
          explanation: "",
        },
        {
          option: "Beed",
          value: "Maharashtra",
          explanation: "",
        },
        {
          option: "Bhandara",
          value: "Maharashtra",
          explanation: "",
        },
        {
          option: "Buldhana",
          value: "Maharashtra",
          explanation: "",
        },
        {
          option: "Chandrapur",
          value: "Maharashtra",
          explanation: "",
        },
        {
          option: "Dhule",
          value: "Maharashtra",
          explanation: "",
        },
        {
          option: "Gadchiroli",
          value: "Maharashtra",
          explanation: "",
        },
        {
          option: "Gondia",
          value: "Maharashtra",
          explanation: "",
        },
        {
          option: "Hingoli",
          value: "Maharashtra",
          explanation: "",
        },
        {
          option: "Jalgaon",
          value: "Maharashtra",
          explanation: "",
        },
        {
          option: "Jalna",
          value: "Maharashtra",
          explanation: "",
        },
        {
          option: "Kolhapur",
          value: "Maharashtra",
          explanation: "",
        },
        {
          option: "Latur",
          value: "Maharashtra",
          explanation: "",
        },
        {
          option: "Mumbai City",
          value: "Maharashtra",
          explanation: "",
        },
        {
          option: "Mumbai Suburban",
          value: "Maharashtra",
          explanation: "",
        },
        {
          option: "Nagpur",
          value: "Maharashtra",
          explanation: "",
        },
        {
          option: "Nanded",
          value: "Maharashtra",
          explanation: "",
        },
        {
          option: "Nandurbar",
          value: "Maharashtra",
          explanation: "",
        },
        {
          option: "Nashik",
          value: "Maharashtra",
          explanation: "",
        },
        {
          option: "Osmanabad",
          value: "Maharashtra",
          explanation: "",
        },
        {
          option: "Palghar",
          value: "Maharashtra",
          explanation: "",
        },
        {
          option: "Parbhani",
          value: "Maharashtra",
          explanation: "",
        },
        {
          option: "Pune",
          value: "Maharashtra",
          explanation: "",
        },
        {
          option: "Raigad",
          value: "Maharashtra",
          explanation: "",
        },
        {
          option: "Ratnagiri",
          value: "Maharashtra",
          explanation: "",
        },
        {
          option: "Sangli",
          value: "Maharashtra",
          explanation: "",
        },
        {
          option: "Satara",
          value: "Maharashtra",
          explanation: "",
        },
        {
          option: "Sindhudurg",
          value: "Maharashtra",
          explanation: "",
        },
        {
          option: "Solapur",
          value: "Maharashtra",
          explanation: "",
        },
        {
          option: "Thane",
          value: "Maharashtra",
          explanation: "",
        },
        {
          option: "Wardha",
          value: "Maharashtra",
          explanation: "",
        },
        {
          option: "Washim",
          value: "Maharashtra",
          explanation: "",
        },
        {
          option: "Yavatmal",
          value: "Maharashtra",
          explanation: "",
        },
        {
          option: "Bishnupur",
          value: "Manipur",
          explanation: "",
        },
        {
          option: "Chandel",
          value: "Manipur",
          explanation: "",
        },
        {
          option: "Churachandpur",
          value: "Manipur",
          explanation: "",
        },
        {
          option: "Imphal East",
          value: "Manipur",
          explanation: "",
        },
        {
          option: "Imphal West",
          value: "Manipur",
          explanation: "",
        },
        {
          option: "Jiribam",
          value: "Manipur",
          explanation: "",
        },
        {
          option: "Kakching",
          value: "Manipur",
          explanation: "",
        },
        {
          option: "Kamjong",
          value: "Manipur",
          explanation: "",
        },
        {
          option: "Kangpokpi",
          value: "Manipur",
          explanation: "",
        },
        {
          option: "Noney",
          value: "Manipur",
          explanation: "",
        },
        {
          option: "Pherzawl",
          value: "Manipur",
          explanation: "",
        },
        {
          option: "Senapati",
          value: "Manipur",
          explanation: "",
        },
        {
          option: "Tamenglong",
          value: "Manipur",
          explanation: "",
        },
        {
          option: "Tengnoupal",
          value: "Manipur",
          explanation: "",
        },
        {
          option: "Thoubal",
          value: "Manipur",
          explanation: "",
        },
        {
          option: "Ukhrul",
          value: "Manipur",
          explanation: "",
        },
        {
          option: "East Garo Hills",
          value: "Meghalaya",
          explanation: "",
        },
        {
          option: "East Jaintia Hills",
          value: "Meghalaya",
          explanation: "",
        },
        {
          option: "East Khasi Hills",
          value: "Meghalaya",
          explanation: "",
        },
        {
          option: "North Garo Hills",
          value: "Meghalaya",
          explanation: "",
        },
        {
          option: "Ri Bhoi",
          value: "Meghalaya",
          explanation: "",
        },
        {
          option: "South Garo Hills",
          value: "Meghalaya",
          explanation: "",
        },
        {
          option: "South West Garo Hills",
          value: "Meghalaya",
          explanation: "",
        },
        {
          option: "South West Khasi Hills",
          value: "Meghalaya",
          explanation: "",
        },
        {
          option: "West Garo Hills",
          value: "Meghalaya",
          explanation: "",
        },
        {
          option: "West Jaintia Hills",
          value: "Meghalaya",
          explanation: "",
        },
        {
          option: "West Khasi Hills",
          value: "Meghalaya",
          explanation: "",
        },
        {
          option: "Aizawl",
          value: "Mizoram",
          explanation: "",
        },
        {
          option: "Champhai",
          value: "Mizoram",
          explanation: "",
        },
        {
          option: "Kolasib",
          value: "Mizoram",
          explanation: "",
        },
        {
          option: "Lawngtlai",
          value: "Mizoram",
          explanation: "",
        },
        {
          option: "Lunglei",
          value: "Mizoram",
          explanation: "",
        },
        {
          option: "Mamit",
          value: "Mizoram",
          explanation: "",
        },
        {
          option: "Saiha",
          value: "Mizoram",
          explanation: "",
        },
        {
          option: "Serchhip",
          value: "Mizoram",
          explanation: "",
        },
        {
          option: "Dimapur",
          value: "Nagaland",
          explanation: "",
        },
        {
          option: "Kiphire",
          value: "Nagaland",
          explanation: "",
        },
        {
          option: "Kohima",
          value: "Nagaland",
          explanation: "",
        },
        {
          option: "Longleng",
          value: "Nagaland",
          explanation: "",
        },
        {
          option: "Mokokchung",
          value: "Nagaland",
          explanation: "",
        },
        {
          option: "Mon",
          value: "Nagaland",
          explanation: "",
        },
        {
          option: "Peren",
          value: "Nagaland",
          explanation: "",
        },
        {
          option: "Phek",
          value: "Nagaland",
          explanation: "",
        },
        {
          option: "Tuensang",
          value: "Nagaland",
          explanation: "",
        },
        {
          option: "Wokha",
          value: "Nagaland",
          explanation: "",
        },
        {
          option: "Zunheboto",
          value: "Nagaland",
          explanation: "",
        },
        {
          option: "Angul",
          value: "Odisha",
          explanation: "",
        },
        {
          option: "Balangir",
          value: "Odisha",
          explanation: "",
        },
        {
          option: "Balasore",
          value: "Odisha",
          explanation: "",
        },
        {
          option: "Bargarh",
          value: "Odisha",
          explanation: "",
        },
        {
          option: "Bhadrak",
          value: "Odisha",
          explanation: "",
        },
        {
          option: "Boudh",
          value: "Odisha",
          explanation: "",
        },
        {
          option: "Cuttack",
          value: "Odisha",
          explanation: "",
        },
        {
          option: "Deogarh",
          value: "Odisha",
          explanation: "",
        },
        {
          option: "Dhenkanal",
          value: "Odisha",
          explanation: "",
        },
        {
          option: "Gajapati",
          value: "Odisha",
          explanation: "",
        },
        {
          option: "Ganjam",
          value: "Odisha",
          explanation: "",
        },
        {
          option: "Jagatsinghapur",
          value: "Odisha",
          explanation: "",
        },
        {
          option: "Jajpur",
          value: "Odisha",
          explanation: "",
        },
        {
          option: "Jharsuguda",
          value: "Odisha",
          explanation: "",
        },
        {
          option: "Kalahandi",
          value: "Odisha",
          explanation: "",
        },
        {
          option: "Kandhamal",
          value: "Odisha",
          explanation: "",
        },
        {
          option: "Kendrapara",
          value: "Odisha",
          explanation: "",
        },
        {
          option: "Kendujhar (Keonjhar)",
          value: "Odisha",
          explanation: "",
        },
        {
          option: "Khordha",
          value: "Odisha",
          explanation: "",
        },
        {
          option: "Koraput",
          value: "Odisha",
          explanation: "",
        },
        {
          option: "Malkangiri",
          value: "Odisha",
          explanation: "",
        },
        {
          option: "Mayurbhanj",
          value: "Odisha",
          explanation: "",
        },
        {
          option: "Nabarangpur",
          value: "Odisha",
          explanation: "",
        },
        {
          option: "Nayagarh",
          value: "Odisha",
          explanation: "",
        },
        {
          option: "Nuapada",
          value: "Odisha",
          explanation: "",
        },
        {
          option: "Puri",
          value: "Odisha",
          explanation: "",
        },
        {
          option: "Rayagada",
          value: "Odisha",
          explanation: "",
        },
        {
          option: "Sambalpur",
          value: "Odisha",
          explanation: "",
        },
        {
          option: "Sonepur",
          value: "Odisha",
          explanation: "",
        },
        {
          option: "Sundargarh",
          value: "Odisha",
          explanation: "",
        },
        {
          option: "Karaikal",
          value: "Puducherry (UT)",
          explanation: "",
        },
        {
          option: "Mahe",
          value: "Puducherry (UT)",
          explanation: "",
        },
        {
          option: "Puducherry",
          value: "Puducherry (UT)",
          explanation: "",
        },
        {
          option: "Yanam",
          value: "Puducherry (UT)",
          explanation: "",
        },
        {
          option: "Amritsar",
          value: "Punjab",
          explanation: "",
        },
        {
          option: "Barnala",
          value: "Punjab",
          explanation: "",
        },
        {
          option: "Bathinda",
          value: "Punjab",
          explanation: "",
        },
        {
          option: "Faridkot",
          value: "Punjab",
          explanation: "",
        },
        {
          option: "Fatehgarh Sahib",
          value: "Punjab",
          explanation: "",
        },
        {
          option: "Fazilka",
          value: "Punjab",
          explanation: "",
        },
        {
          option: "Ferozepur",
          value: "Punjab",
          explanation: "",
        },
        {
          option: "Gurdaspur",
          value: "Punjab",
          explanation: "",
        },
        {
          option: "Hoshiarpur",
          value: "Punjab",
          explanation: "",
        },
        {
          option: "Jalandhar",
          value: "Punjab",
          explanation: "",
        },
        {
          option: "Kapurthala",
          value: "Punjab",
          explanation: "",
        },
        {
          option: "Ludhiana",
          value: "Punjab",
          explanation: "",
        },
        {
          option: "Mansa",
          value: "Punjab",
          explanation: "",
        },
        {
          option: "Moga",
          value: "Punjab",
          explanation: "",
        },
        {
          option: "Muktsar",
          value: "Punjab",
          explanation: "",
        },
        {
          option: "Nawanshahr (Shahid Bhagat Singh Nagar)",
          value: "Punjab",
          explanation: "",
        },
        {
          option: "Pathankot",
          value: "Punjab",
          explanation: "",
        },
        {
          option: "Patiala",
          value: "Punjab",
          explanation: "",
        },
        {
          option: "Rupnagar",
          value: "Punjab",
          explanation: "",
        },
        {
          option: "Sahibzada Ajit Singh Nagar (Mohali)",
          value: "Punjab",
          explanation: "",
        },
        {
          option: "Sangrur",
          value: "Punjab",
          explanation: "",
        },
        {
          option: "Tarn Taran",
          value: "Punjab",
          explanation: "",
        },
        {
          option: "Ajmer",
          value: "Rajasthan",
          explanation: "",
        },
        {
          option: "Alwar",
          value: "Rajasthan",
          explanation: "",
        },
        {
          option: "Banswara",
          value: "Rajasthan",
          explanation: "",
        },
        {
          option: "Baran",
          value: "Rajasthan",
          explanation: "",
        },
        {
          option: "Barmer",
          value: "Rajasthan",
          explanation: "",
        },
        {
          option: "Bharatpur",
          value: "Rajasthan",
          explanation: "",
        },
        {
          option: "Bhilwara",
          value: "Rajasthan",
          explanation: "",
        },
        {
          option: "Bikaner",
          value: "Rajasthan",
          explanation: "",
        },
        {
          option: "Bundi",
          value: "Rajasthan",
          explanation: "",
        },
        {
          option: "Chittorgarh",
          value: "Rajasthan",
          explanation: "",
        },
        {
          option: "Churu",
          value: "Rajasthan",
          explanation: "",
        },
        {
          option: "Dausa",
          value: "Rajasthan",
          explanation: "",
        },
        {
          option: "Dholpur",
          value: "Rajasthan",
          explanation: "",
        },
        {
          option: "Dungarpur",
          value: "Rajasthan",
          explanation: "",
        },
        {
          option: "Hanumangarh",
          value: "Rajasthan",
          explanation: "",
        },
        {
          option: "Jaipur",
          value: "Rajasthan",
          explanation: "",
        },
        {
          option: "Jaisalmer",
          value: "Rajasthan",
          explanation: "",
        },
        {
          option: "Jalore",
          value: "Rajasthan",
          explanation: "",
        },
        {
          option: "Jhalawar",
          value: "Rajasthan",
          explanation: "",
        },
        {
          option: "Jhunjhunu",
          value: "Rajasthan",
          explanation: "",
        },
        {
          option: "Jodhpur",
          value: "Rajasthan",
          explanation: "",
        },
        {
          option: "Karauli",
          value: "Rajasthan",
          explanation: "",
        },
        {
          option: "Kota",
          value: "Rajasthan",
          explanation: "",
        },
        {
          option: "Nagaur",
          value: "Rajasthan",
          explanation: "",
        },
        {
          option: "Pali",
          value: "Rajasthan",
          explanation: "",
        },
        {
          option: "Pratapgarh",
          value: "Rajasthan",
          explanation: "",
        },
        {
          option: "Rajsamand",
          value: "Rajasthan",
          explanation: "",
        },
        {
          option: "Sawai Madhopur",
          value: "Rajasthan",
          explanation: "",
        },
        {
          option: "Sikar",
          value: "Rajasthan",
          explanation: "",
        },
        {
          option: "Sirohi",
          value: "Rajasthan",
          explanation: "",
        },
        {
          option: "Sri Ganganagar",
          value: "Rajasthan",
          explanation: "",
        },
        {
          option: "Tonk",
          value: "Rajasthan",
          explanation: "",
        },
        {
          option: "Udaipur",
          value: "Rajasthan",
          explanation: "",
        },
        {
          option: "East Sikkim",
          value: "Sikkim",
          explanation: "",
        },
        {
          option: "North Sikkim",
          value: "Sikkim",
          explanation: "",
        },
        {
          option: "South Sikkim",
          value: "Sikkim",
          explanation: "",
        },
        {
          option: "West Sikkim",
          value: "Sikkim",
          explanation: "",
        },
        {
          option: "Ariyalur",
          value: "Tamil Nadu",
          explanation: "",
        },
        {
          option: "Chengalpattu",
          value: "Tamil Nadu",
          explanation: "",
        },
        {
          option: "Chennai",
          value: "Tamil Nadu",
          explanation: "",
        },
        {
          option: "Coimbatore",
          value: "Tamil Nadu",
          explanation: "",
        },
        {
          option: "Cuddalore",
          value: "Tamil Nadu",
          explanation: "",
        },
        {
          option: "Dharmapuri",
          value: "Tamil Nadu",
          explanation: "",
        },
        {
          option: "Dindigul",
          value: "Tamil Nadu",
          explanation: "",
        },
        {
          option: "Erode",
          value: "Tamil Nadu",
          explanation: "",
        },
        {
          option: "Kallakurichi",
          value: "Tamil Nadu",
          explanation: "",
        },
        {
          option: "Kanchipuram",
          value: "Tamil Nadu",
          explanation: "",
        },
        {
          option: "Kanyakumari",
          value: "Tamil Nadu",
          explanation: "",
        },
        {
          option: "Karur",
          value: "Tamil Nadu",
          explanation: "",
        },
        {
          option: "Krishnagiri",
          value: "Tamil Nadu",
          explanation: "",
        },
        {
          option: "Madurai",
          value: "Tamil Nadu",
          explanation: "",
        },
        {
          option: "Nagapattinam",
          value: "Tamil Nadu",
          explanation: "",
        },
        {
          option: "Namakkal",
          value: "Tamil Nadu",
          explanation: "",
        },
        {
          option: "Nilgiris",
          value: "Tamil Nadu",
          explanation: "",
        },
        {
          option: "Perambalur",
          value: "Tamil Nadu",
          explanation: "",
        },
        {
          option: "Pudukkottai",
          value: "Tamil Nadu",
          explanation: "",
        },
        {
          option: "Ramanathapuram",
          value: "Tamil Nadu",
          explanation: "",
        },
        {
          option: "Ranipet",
          value: "Tamil Nadu",
          explanation: "",
        },
        {
          option: "Salem",
          value: "Tamil Nadu",
          explanation: "",
        },
        {
          option: "Sivaganga",
          value: "Tamil Nadu",
          explanation: "",
        },
        {
          option: "Tenkasi",
          value: "Tamil Nadu",
          explanation: "",
        },
        {
          option: "Thanjavur",
          value: "Tamil Nadu",
          explanation: "",
        },
        {
          option: "Theni",
          value: "Tamil Nadu",
          explanation: "",
        },
        {
          option: "Thoothukudi (Tuticorin)",
          value: "Tamil Nadu",
          explanation: "",
        },
        {
          option: "Tiruchirappalli",
          value: "Tamil Nadu",
          explanation: "",
        },
        {
          option: "Tirunelveli",
          value: "Tamil Nadu",
          explanation: "",
        },
        {
          option: "Tirupathur",
          value: "Tamil Nadu",
          explanation: "",
        },
        {
          option: "Tiruppur",
          value: "Tamil Nadu",
          explanation: "",
        },
        {
          option: "Tiruvallur",
          value: "Tamil Nadu",
          explanation: "",
        },
        {
          option: "Tiruvannamalai",
          value: "Tamil Nadu",
          explanation: "",
        },
        {
          option: "Tiruvarur",
          value: "Tamil Nadu",
          explanation: "",
        },
        {
          option: "Vellore",
          value: "Tamil Nadu",
          explanation: "",
        },
        {
          option: "Viluppuram",
          value: "Tamil Nadu",
          explanation: "",
        },
        {
          option: "Virudhunagar",
          value: "Tamil Nadu",
          explanation: "",
        },
        {
          option: "Adilabad",
          value: "Telangana",
          explanation: "",
        },
        {
          option: "Bhadradri Kothagudem",
          value: "Telangana",
          explanation: "",
        },
        {
          option: "Hyderabad",
          value: "Telangana",
          explanation: "",
        },
        {
          option: "Jagtial",
          value: "Telangana",
          explanation: "",
        },
        {
          option: "Jangaon",
          value: "Telangana",
          explanation: "",
        },
        {
          option: "Jayashankar Bhoopalpally",
          value: "Telangana",
          explanation: "",
        },
        {
          option: "Jogulamba Gadwal",
          value: "Telangana",
          explanation: "",
        },
        {
          option: "Kamareddy",
          value: "Telangana",
          explanation: "",
        },
        {
          option: "Karimnagar",
          value: "Telangana",
          explanation: "",
        },
        {
          option: "Khammam",
          value: "Telangana",
          explanation: "",
        },
        {
          option: "Komaram Bheem Asifabad",
          value: "Telangana",
          explanation: "",
        },
        {
          option: "Mahabubabad",
          value: "Telangana",
          explanation: "",
        },
        {
          option: "Mahabubnagar",
          value: "Telangana",
          explanation: "",
        },
        {
          option: "Mancherial",
          value: "Telangana",
          explanation: "",
        },
        {
          option: "Medak",
          value: "Telangana",
          explanation: "",
        },
        {
          option: "Medchal",
          value: "Telangana",
          explanation: "",
        },
        {
          option: "Nagarkurnool",
          value: "Telangana",
          explanation: "",
        },
        {
          option: "Nalgonda",
          value: "Telangana",
          explanation: "",
        },
        {
          option: "Nirmal",
          value: "Telangana",
          explanation: "",
        },
        {
          option: "Nizamabad",
          value: "Telangana",
          explanation: "",
        },
        {
          option: "Peddapalli",
          value: "Telangana",
          explanation: "",
        },
        {
          option: "Rajanna Sircilla",
          value: "Telangana",
          explanation: "",
        },
        {
          option: "Rangareddy",
          value: "Telangana",
          explanation: "",
        },
        {
          option: "Sangareddy",
          value: "Telangana",
          explanation: "",
        },
        {
          option: "Siddipet",
          value: "Telangana",
          explanation: "",
        },
        {
          option: "Suryapet",
          value: "Telangana",
          explanation: "",
        },
        {
          option: "Vikarabad",
          value: "Telangana",
          explanation: "",
        },
        {
          option: "Wanaparthy",
          value: "Telangana",
          explanation: "",
        },
        {
          option: "Warangal (Rural)",
          value: "Telangana",
          explanation: "",
        },
        {
          option: "Warangal (Urban)",
          value: "Telangana",
          explanation: "",
        },
        {
          option: "Yadadri Bhuvanagiri",
          value: "Telangana",
          explanation: "",
        },
        {
          option: "Dhalai",
          value: "Tripura",
          explanation: "",
        },
        {
          option: "Gomati",
          value: "Tripura",
          explanation: "",
        },
        {
          option: "Khowai",
          value: "Tripura",
          explanation: "",
        },
        {
          option: "North Tripura",
          value: "Tripura",
          explanation: "",
        },
        {
          option: "Sepahijala",
          value: "Tripura",
          explanation: "",
        },
        {
          option: "South Tripura",
          value: "Tripura",
          explanation: "",
        },
        {
          option: "Unakoti",
          value: "Tripura",
          explanation: "",
        },
        {
          option: "West Tripura",
          value: "Tripura",
          explanation: "",
        },
        {
          option: "Almora",
          value: "Uttarakhand",
          explanation: "",
        },
        {
          option: "Bageshwar",
          value: "Uttarakhand",
          explanation: "",
        },
        {
          option: "Chamoli",
          value: "Uttarakhand",
          explanation: "",
        },
        {
          option: "Champawat",
          value: "Uttarakhand",
          explanation: "",
        },
        {
          option: "Dehradun",
          value: "Uttarakhand",
          explanation: "",
        },
        {
          option: "Haridwar",
          value: "Uttarakhand",
          explanation: "",
        },
        {
          option: "Nainital",
          value: "Uttarakhand",
          explanation: "",
        },
        {
          option: "Pauri Garhwal",
          value: "Uttarakhand",
          explanation: "",
        },
        {
          option: "Pithoragarh",
          value: "Uttarakhand",
          explanation: "",
        },
        {
          option: "Rudraprayag",
          value: "Uttarakhand",
          explanation: "",
        },
        {
          option: "Tehri Garhwal",
          value: "Uttarakhand",
          explanation: "",
        },
        {
          option: "Udham Singh Nagar",
          value: "Uttarakhand",
          explanation: "",
        },
        {
          option: "Uttarkashi",
          value: "Uttarakhand",
          explanation: "",
        },
        {
          option: "Agra",
          value: "Uttar Pradesh",
          explanation: "",
        },
        {
          option: "Aligarh",
          value: "Uttar Pradesh",
          explanation: "",
        },
        {
          option: "Allahabad",
          value: "Uttar Pradesh",
          explanation: "",
        },
        {
          option: "Ambedkar Nagar",
          value: "Uttar Pradesh",
          explanation: "",
        },
        {
          option: "Amethi (Chatrapati Sahuji Mahraj Nagar)",
          value: "Uttar Pradesh",
          explanation: "",
        },
        {
          option: "Amroha (J.P. Nagar)",
          value: "Uttar Pradesh",
          explanation: "",
        },
        {
          option: "Auraiya",
          value: "Uttar Pradesh",
          explanation: "",
        },
        {
          option: "Azamgarh",
          value: "Uttar Pradesh",
          explanation: "",
        },
        {
          option: "Baghpat",
          value: "Uttar Pradesh",
          explanation: "",
        },
        {
          option: "Bahraich",
          value: "Uttar Pradesh",
          explanation: "",
        },
        {
          option: "Ballia",
          value: "Uttar Pradesh",
          explanation: "",
        },
        {
          option: "Balrampur (UP)",
          value: "Uttar Pradesh",
          explanation: "",
        },
        {
          option: "Banda",
          value: "Uttar Pradesh",
          explanation: "",
        },
        {
          option: "Barabanki",
          value: "Uttar Pradesh",
          explanation: "",
        },
        {
          option: "Bareilly",
          value: "Uttar Pradesh",
          explanation: "",
        },
        {
          option: "Basti",
          value: "Uttar Pradesh",
          explanation: "",
        },
        {
          option: "Bhadohi",
          value: "Uttar Pradesh",
          explanation: "",
        },
        {
          option: "Bijnor",
          value: "Uttar Pradesh",
          explanation: "",
        },
        {
          option: "Budaun",
          value: "Uttar Pradesh",
          explanation: "",
        },
        {
          option: "Bulandshahr",
          value: "Uttar Pradesh",
          explanation: "",
        },
        {
          option: "Chandauli",
          value: "Uttar Pradesh",
          explanation: "",
        },
        {
          option: "Chitrakoot",
          value: "Uttar Pradesh",
          explanation: "",
        },
        {
          option: "Deoria",
          value: "Uttar Pradesh",
          explanation: "",
        },
        {
          option: "Etah",
          value: "Uttar Pradesh",
          explanation: "",
        },
        {
          option: "Etawah",
          value: "Uttar Pradesh",
          explanation: "",
        },
        {
          option: "Faizabad",
          value: "Uttar Pradesh",
          explanation: "",
        },
        {
          option: "Farrukhabad",
          value: "Uttar Pradesh",
          explanation: "",
        },
        {
          option: "Fatehpur",
          value: "Uttar Pradesh",
          explanation: "",
        },
        {
          option: "Firozabad",
          value: "Uttar Pradesh",
          explanation: "",
        },
        {
          option: "Gautam Buddha Nagar",
          value: "Uttar Pradesh",
          explanation: "",
        },
        {
          option: "Ghaziabad",
          value: "Uttar Pradesh",
          explanation: "",
        },
        {
          option: "Ghazipur",
          value: "Uttar Pradesh",
          explanation: "",
        },
        {
          option: "Gonda",
          value: "Uttar Pradesh",
          explanation: "",
        },
        {
          option: "Gorakhpur",
          value: "Uttar Pradesh",
          explanation: "",
        },
        {
          option: "Hamirpur",
          value: "Uttar Pradesh",
          explanation: "",
        },
        {
          option: "Hapur (Panchsheel Nagar)",
          value: "Uttar Pradesh",
          explanation: "",
        },
        {
          option: "Hardoi",
          value: "Uttar Pradesh",
          explanation: "",
        },
        {
          option: "Hathras",
          value: "Uttar Pradesh",
          explanation: "",
        },
        {
          option: "Jalaun",
          value: "Uttar Pradesh",
          explanation: "",
        },
        {
          option: "Jaunpur",
          value: "Uttar Pradesh",
          explanation: "",
        },
        {
          option: "Jhansi",
          value: "Uttar Pradesh",
          explanation: "",
        },
        {
          option: "Kannauj",
          value: "Uttar Pradesh",
          explanation: "",
        },
        {
          option: "Kanpur Dehat",
          value: "Uttar Pradesh",
          explanation: "",
        },
        {
          option: "Kanpur Nagar",
          value: "Uttar Pradesh",
          explanation: "",
        },
        {
          option: "Kanshiram Nagar (Kasganj)",
          value: "Uttar Pradesh",
          explanation: "",
        },
        {
          option: "Kaushambi",
          value: "Uttar Pradesh",
          explanation: "",
        },
        {
          option: "Kushinagar (Padrauna)",
          value: "Uttar Pradesh",
          explanation: "",
        },
        {
          option: "Lakhimpur - Kheri",
          value: "Uttar Pradesh",
          explanation: "",
        },
        {
          option: "Lalitpur",
          value: "Uttar Pradesh",
          explanation: "",
        },
        {
          option: "Lucknow",
          value: "Uttar Pradesh",
          explanation: "",
        },
        {
          option: "Maharajganj",
          value: "Uttar Pradesh",
          explanation: "",
        },
        {
          option: "Mahoba",
          value: "Uttar Pradesh",
          explanation: "",
        },
        {
          option: "Mainpuri",
          value: "Uttar Pradesh",
          explanation: "",
        },
        {
          option: "Mathura",
          value: "Uttar Pradesh",
          explanation: "",
        },
        {
          option: "Mau",
          value: "Uttar Pradesh",
          explanation: "",
        },
        {
          option: "Meerut",
          value: "Uttar Pradesh",
          explanation: "",
        },
        {
          option: "Mirzapur",
          value: "Uttar Pradesh",
          explanation: "",
        },
        {
          option: "Moradabad",
          value: "Uttar Pradesh",
          explanation: "",
        },
        {
          option: "Muzaffarnagar",
          value: "Uttar Pradesh",
          explanation: "",
        },
        {
          option: "Pilibhit",
          value: "Uttar Pradesh",
          explanation: "",
        },
        {
          option: "Pratapgarh (UP)",
          value: "Uttar Pradesh",
          explanation: "",
        },
        {
          option: "RaeBareli",
          value: "Uttar Pradesh",
          explanation: "",
        },
        {
          option: "Rampur",
          value: "Uttar Pradesh",
          explanation: "",
        },
        {
          option: "Saharanpur",
          value: "Uttar Pradesh",
          explanation: "",
        },
        {
          option: "Sambhal (Bhim Nagar)",
          value: "Uttar Pradesh",
          explanation: "",
        },
        {
          option: "Sant Kabir Nagar",
          value: "Uttar Pradesh",
          explanation: "",
        },
        {
          option: "Shahjahanpur",
          value: "Uttar Pradesh",
          explanation: "",
        },
        {
          option: "Shamali (Prabuddh Nagar)",
          value: "Uttar Pradesh",
          explanation: "",
        },
        {
          option: "Shravasti",
          value: "Uttar Pradesh",
          explanation: "",
        },
        {
          option: "Siddharth Nagar",
          value: "Uttar Pradesh",
          explanation: "",
        },
        {
          option: "Sitapur",
          value: "Uttar Pradesh",
          explanation: "",
        },
        {
          option: "Sonbhadra",
          value: "Uttar Pradesh",
          explanation: "",
        },
        {
          option: "Sultanpur",
          value: "Uttar Pradesh",
          explanation: "",
        },
        {
          option: "Unnao",
          value: "Uttar Pradesh",
          explanation: "",
        },
        {
          option: "Varanasi",
          value: "Uttar Pradesh",
          explanation: "",
        },
        {
          option: "Alipurduar",
          value: "West Bengal",
          explanation: "",
        },
        {
          option: "Bankura",
          value: "West Bengal",
          explanation: "",
        },
        {
          option: "Birbhum",
          value: "West Bengal",
          explanation: "",
        },
        {
          option: "Cooch Behar",
          value: "West Bengal",
          explanation: "",
        },
        {
          option: "Dakshin Dinajpur (South Dinajpur)",
          value: "West Bengal",
          explanation: "",
        },
        {
          option: "Darjeeling",
          value: "West Bengal",
          explanation: "",
        },
        {
          option: "Hooghly",
          value: "West Bengal",
          explanation: "",
        },
        {
          option: "Howrah",
          value: "West Bengal",
          explanation: "",
        },
        {
          option: "Jalpaiguri",
          value: "West Bengal",
          explanation: "",
        },
        {
          option: "Jhargram",
          value: "West Bengal",
          explanation: "",
        },
        {
          option: "Kalimpong",
          value: "West Bengal",
          explanation: "",
        },
        {
          option: "Kolkata",
          value: "West Bengal",
          explanation: "",
        },
        {
          option: "Malda",
          value: "West Bengal",
          explanation: "",
        },
        {
          option: "Murshidabad",
          value: "West Bengal",
          explanation: "",
        },
        {
          option: "Nadia",
          value: "West Bengal",
          explanation: "",
        },
        {
          option: "North 24 Parganas",
          value: "West Bengal",
          explanation: "",
        },
        {
          option: "Paschim (West) Burdwan (Bardhaman)",
          value: "West Bengal",
          explanation: "",
        },
        {
          option: "Paschim Medinipur (West Medinipur)",
          value: "West Bengal",
          explanation: "",
        },
        {
          option: "Purba Burdwan (Bardhaman)",
          value: "West Bengal",
          explanation: "",
        },
        {
          option: "Purba Medinipur (East Medinipur)",
          value: "West Bengal",
          explanation: "",
        },
        {
          option: "Purulia",
          value: "West Bengal",
          explanation: "",
        },
        {
          option: "South 24 Parganas",
          value: "West Bengal",
          explanation: "",
        },
        {
          option: "Uttar Dinajpur (North Dinajpur)",
          value: "West Bengal",
          explanation: "",
        },
      ]
    , 
    mandatory: 0,
  },
  ]},
  {
    label: 'Select all options of interest to you',
    name: 'beneficiary_groups',
    isCustomInput: true,
    mandatory: 0,
    options: [
      { option: 'Accident Victims' },
      { option: 'Acid Attack Survivors' },
      { option: 'Adolescents' },
      { option: 'Adults' },
      { option: 'Animal Lovers' },
      { option: 'Animals / Birds' },
      { option: 'Armed Forces' },
      { option: 'Artists' },
      { option: 'Beggars' },
      { option: 'Blood Donors' },
      { option: 'Children' },
      { option: 'Chronically Ill' },
      { option: 'Craftspersons' },
      { option: 'Labourers' },
      { option: 'COVID Affected' },
      { option: 'Dalits' },
      { option: 'Disaster Affected' },
      { option: 'Displaced Persons' },
      { option: 'Domestic Violence Victims' },
      { option: 'Domestic Workers' },
      { option: 'Elderly' },
      { option: 'Ethnic Groups' },
      { option: 'Factory Workers' },
      { option: 'Farmers / Farm Labourers' },
      { option: 'Firemen' },
      { option: 'Freedom Fighters' },
      { option: 'Girl Child' },
      { option: 'Healthcare Workers' },
      { option: 'HIV+' },
      { option: 'Homeless' },
      { option: 'Juvenile' },
      { option: 'Legal Workers' },
      { option: 'Lesbian, Gays, Bisexuals, Transgenders' },
      { option: 'Medical Practitioners' },
      { option: 'Mentally Challenged' },
      { option: 'Migrants' },
      { option: 'NGOs' },
      { option: 'Organ Donors' },
      { option: 'Orphans' },
      { option: 'Patients' },
      { option: 'Physically Challenged' },
      { option: 'Plants' },
      { option: 'Policemen' },
      { option: 'Porters' },
      { option: 'Prisoners' },
      { option: 'Refugees' },
      { option: 'Rickshawallahs / Drivers' },
      { option: 'Rural Poor' },
      { option: 'Salt Workers' },
      { option: 'Scavengers (human)' },
      { option: 'Self Help Groups' },
      { option: 'Sex Workers' },
      { option: 'Slum Dwellers' },
      { option: 'Sportspersons' },
      { option: 'Street Children' },
      { option: 'Students' },
      { option: 'Teachers' },
      { option: 'Tribals' },
      { option: 'Truckers' },
      { option: 'Urban poor' },
      { option: 'Volunteers' },
      { option: 'Victims of Violence' },
      { option: 'War victims' },
      { option: 'Weavers' },
      { option: 'Widows' },
      { option: 'Women' },
      { option: 'Youth' },
      { option: 'Others' }
  ]
  },
  {
    label: 'Periodic Insights & Updates',
    name: 'periodic_insights',
  },
];






export const purposedocuments = [
  {
    type: 'dropdown', 
    question_no: 'fcra', 
    question: 'Please select', 
    description: 'If you are a Foreign National/ Institutions as per FCRA then please select ', 
    depend_question: '', 
    condition: 'equals', 
    value: 'yes', 
    validation:'dropdown', 
    options: [{"option": "Yes"}]
    , 
    mandatory: 0,
  },
  {
    type: 'text', 
    question_no: 'tags', 
    question: 'Tags', 
    description: 'Enter keywords of your interest separated by comma', 
    depend_question: '', 
    condition: 'equals', 
    value: 'yes', 
    validation:'text', 
    options: []
    , 
    mandatory: 0,
  }
]


export const userdocuments = [
  {
    type: 'dropdown', 
    question_no: 'type_of_user', 
    question: 'Type of User', 
    description: 'Select Yes if you can support only NPOs that are eligible to receive from foreign nationals and institutions', 
    depend_question: '', 
    condition: 'equals', 
    value: 'yes', 
    validation:'dropdown', 
    options: [{"option": "Individual"},{"option": "Institutional/ Group"}]
    , 
    mandatory: 1,
  },
  {
    type: 'dropdown', 
    question_no: 'select_here', 
    question: 'Organisation Type', 
    description: 'Select one that best describes your organisation/group', 
    depend_question: '', 
    condition: 'equals', 
    value: 'yes', 
    validation:'dropdown', 
    options: [
      { option: 'Corporate' },
      { option: 'Government' },
      { option: 'Audit and consulting firms' },
      { option: 'Grant making foundation' },
      { option: 'Donation platform' },
      { option: 'Volunteering platform' },
      { option: 'In-kind giving platform' },
      { option: 'NPO sector service provider' },
      { option: 'NPO sector ecosystem builder' },
      { option: 'NPO network' },
      { option: 'Research organisation' },
      { option: 'Academic institution' },
      { option: 'Trade and industry association' },
      { option: 'Media' },
      { option: 'Event organiser' },
      { option: 'Volunteering team leader' },
      { option: 'Other' }
    ]
    , 
    mandatory: false,
  },
  {
    type: 'text', 
    question_no: 'other2', 
    question: 'Other (Please Specify)', 
    description: '', 
    depend_question: 'select_here', 
    condition: 'equals', 
    value: 'yes', 
    validation:'text', 
    options: []
    , 
    mandatory: false,
  },
  {
    type: 'text', 
    question_no: 'name_of_institution', 
    question: 'Name of Institution/group', 
    description: '', 
    depend_question: '', 
    condition: 'equals', 
    value: 'yes', 
    validation:'text', 
    options: []
    , 
    mandatory: false,
  },
]


export const UserCheckBoxData = [
  {
    label: 'NPO Sector Professional',
    name: 'npo_sector_professional',
  },
  {
    label: 'CSR Professional',
    name: 'csr_professional',
  },
  {
    label: 'Government Employee',
    name: 'government_employee',
  },
  {
    label: 'Corporate Employee',
    name: 'corporate_employee',
  },
  {
    label: 'Student',
    name: 'student',
  },
  {
    label: 'Academia',
    name: 'academia',
  },
  {
    label: 'Media person',
    name: 'media_person',
  },
  {
    label: 'Impact assessor',
    name: 'impact_assessor',
  },
  {
    label: 'Financial auditor',
    name: 'financial_auditor',
  },
  {
    label: 'Consultant to NPO',
    name: 'consultant_to_npo',
  },
  {
    label: 'Advisor to donors',
    name: 'advisor_to_donors',
  },
  {
    label: 'Participant in events for a cause',
    name: 'participant_in_events_for_a_cause',
  },
  {
    label: 'Fundraiser',
    name: 'fundraiser',
  },
  {
    label: 'Philanthropist',
    name: 'philanthropist',
  },
  {
    label: 'Other (Please Specify)',
    name: 'other1',
    isCustomInput: true,
    mandatory: false,
    options: []
  },


]